import { Modal, Table } from "antd";

const CourseFeedbackModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  questionsRatingObj = {},
  additionalCommentsList = [],
  feedbackCount = 0
}) => {
  const questionsTableColumns = [
    {
      title: "Question",
      dataIndex: "question",
      key: "question"
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating"
    }
  ];

  const additionalCommentsTableColumns = [
    {
      title: "Comments",
      dataIndex: "comment",
      key: "comment"
    }
  ];
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Course Feedback"
      open={isModalOpen}
      footer={[]}
      width={2000}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <>
        <h2>Total Feedbacks: {feedbackCount}</h2>
        <h3>General</h3>
        <Table
          columns={questionsTableColumns}
          dataSource={Object.keys(questionsRatingObj).map((question) => {
            return {
              question,
              rating: questionsRatingObj[question]
            };
          })}
          bordered
          pagination={false}
          scroll={{ x: 500 }}
        />
        <h3>Comments</h3>
        <Table
          columns={additionalCommentsTableColumns}
          dataSource={(additionalCommentsList || []).map((comment) => {
            return {
              comment
            };
          })}
          bordered
          pagination={false}
          scroll={{ x: 500 }}
        />
      </>
    </Modal>
  );
};
export default CourseFeedbackModal;
